import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export const ProtectedRoute = ({ children, requireAdmin = false }) => {
    const { user, loading, initialized, isAuthenticated, isAdmin } = useAuth();
    const location = useLocation();

    // Show loading while checking auth
    if (!initialized || loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-background">
                <div className="text-center">
                    <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4" />
                    <p className="text-muted-foreground">Cargando...</p>
                </div>
            </div>
        );
    }

    // Check if user passed from AuthCallback
    if (location.state?.user) {
        // User was just authenticated, render children
        if (requireAdmin && !location.state.user.is_admin) {
            return <Navigate to="/dashboard" replace />;
        }
        return children;
    }

    // Not authenticated
    if (!isAuthenticated) {
        return <Navigate to="/" replace />;
    }

    // Check admin requirement
    if (requireAdmin && !isAdmin) {
        return <Navigate to="/dashboard" replace />;
    }

    return children;
};

export default ProtectedRoute;
